import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { auditLogsRouter } from './routing/auditLogsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { auditLogsAccessControl } from './access-control/auditLogsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'audit-logs',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'audit-logs-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [auditLogsRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.UserMenuUserManagement,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'View audit logs and user activity history',
          labelId: 'auditLogsDomain.title',
          route: 'audit-logs-list',
          accessControl: auditLogsAccessControl,
          id: 'audit-logs-list',
          positionNavV2: 2,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
